export { default } from 'pages/authentication/auth-deeplink';
